var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1371px",
    height: "586px",
    viewBox: "0 0 1371 586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2CFB1",
    stopOpacity: 0.486611213,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2CFB1",
    offset: "50.0530963%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2CFB1",
    stopOpacity: 0.552024895,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.5654936%",
    y1: "48.415863%",
    x2: "96.7786283%",
    y2: "51.5604461%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CB64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7100",
    offset: "26.9345763%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CB64",
    offset: "34.9726323%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9225",
    offset: "46.8190724%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A37F27",
    offset: "46.9043047%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CB64",
    offset: "60.6599565%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A98220",
    offset: "84.988185%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CB64",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Neon-Idea-1",
    transform: "translate(-307.000000, -228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(307.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graph",
    opacity: 0.200000003,
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 303,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 265,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 275,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 246,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 208,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 227,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 237,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 208,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 199,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 218,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 237,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 275,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 246,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 189,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 208,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429,
    y: 170,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458,
    y: 180,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 142,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 114,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 95,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572,
    y: 133,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 104,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629,
    y: 142,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667,
    y: 152,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696,
    y: 170,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 189,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 753,
    y: 218,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782,
    y: 189,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811,
    y: 208,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839,
    y: 161,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 869,
    y: 152,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 897,
    y: 170,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926,
    y: 123,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 954,
    y: 104,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 983,
    y: 123,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1012,
    y: 85,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 66,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1069,
    y: 95,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1097,
    y: 76,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1126,
    y: 114,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155,
    y: 76,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1183,
    y: 47,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1212,
    y: 9,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 38,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269,
    y: 19,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1298,
    y: 47,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1326,
    y: 19,
    width: 16,
    height: 283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1355,
    y: 0,
    width: 16,
    height: 283
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1227.33019,162.829568 L1227.07481,329.1041 L1240.10092,329.1041 L1240.10092,162.829568 L1322.34422,162.829568 L1322.34422,148.7818 L1145.0869,148.7818 L1145.0869,162.829568 L1227.33019,162.829568 Z M696.30305,148.7818 C729.677161,148.7818 754.750289,155.763128 771.522527,169.725761 C788.294644,183.688392 796.68072,206.760786 796.68072,238.942988 C796.68072,270.784572 788.464955,315.311816 771.522472,329.615012 C768.034583,332.55951 764.199306,326.30798 760.014057,319.806652 L759.53876,319.070066 L759.53876,319.070066 L759.060472,318.334231 C755.622022,313.070321 751.953077,308.08642 748.052257,308.160218 C743.46968,308.246923 739.015765,313.778847 734.661938,319.22631 L734.009611,320.042104 C730.100111,324.924777 726.270523,329.515083 722.500016,329.781885 C719.339272,330.005537 714.937409,324.936457 710.354408,319.65097 L709.698575,318.894976 L709.698575,318.894976 L709.040965,318.139327 C704.542787,312.984393 699.968193,308.083946 696.303237,308.160278 C692.996767,308.229146 689.465943,312.545032 685.805084,317.288713 L685.225987,318.040713 C685.129295,318.166453 685.032517,318.292351 684.935654,318.418335 L684.353469,319.174737 L684.353469,319.174737 L683.76933,319.929896 C679.771219,325.078297 675.641956,329.905693 671.500007,329.615012 C668.203606,329.930385 663.836441,324.229393 659.128328,318.625693 L658.498623,317.879647 C654.287975,312.917003 649.833563,308.245923 645.647959,308.160224 C638.016123,308.003989 628.15012,335.325426 621.338874,329.615022 C604.481549,315.482145 595.9253,271.125125 595.9253,238.942988 C595.9253,207.101375 604.396534,184.114096 621.339003,169.981167 C638.281474,155.848266 663.269501,148.7818 696.30305,148.7818 Z M984.467824,148.782332 C991.282475,148.792963 996.502317,148.963069 1000.12754,149.292618 C1005.06555,149.292618 1010.855,149.888588 1017.49568,151.080522 C1031.11775,153.804951 1040.82356,159.168648 1046.61291,167.171616 C1050.35898,172.109622 1052.65774,177.388175 1053.50908,183.007275 C1054.19014,186.583076 1054.53072,192.202175 1054.53072,199.864594 L1054.53072,199.864594 L1054.53072,201.907911 L1042.01549,201.907911 L1042.01549,199.864594 C1042.01549,194.075224 1041.76011,189.818323 1041.24924,187.093887 C1040.73836,183.007266 1039.20597,179.346343 1036.65182,176.111094 C1032.56517,170.321717 1026.26496,166.618212 1017.75117,165.000585 C1009.23739,163.38298 999.191114,162.574166 987.612318,162.574159 L987.612318,162.574159 L952.620551,162.574159 C941.041758,162.574166 930.995471,163.38298 922.481697,165.000585 C913.967919,166.618212 907.582503,170.321717 903.325668,176.111094 C901.282289,178.835505 899.962724,181.730195 899.366761,184.795178 C898.770799,187.860142 898.472762,191.861622 898.472762,196.799634 L898.472762,196.799634 L898.472762,200.630839 C898.472762,208.293257 900.175561,214.295492 903.581051,218.637523 C906.98654,222.979576 911.754354,226.172245 917.884278,228.215558 C922.822277,230.088602 929.122494,231.280533 936.784923,231.79136 C941.119629,231.951912 947.346507,232.036765 955.465549,232.045939 L985.313551,232.046772 C992.294822,232.046772 998.382205,232.174475 1003.5757,232.429898 C1008.76907,232.685319 1013.83481,233.323844 1018.77281,234.345494 C1031.8841,237.069915 1041.58981,242.433604 1047.89004,250.436578 C1051.80629,255.034028 1054.27534,260.567994 1055.29698,267.038481 C1055.80785,271.125125 1056.06323,275.38203 1056.06323,279.809194 L1056.06323,279.809194 L1056.06323,284.151229 C1056.06323,297.43276 1052.61509,307.351352 1045.71891,313.906987 C1038.82273,320.462605 1030.43669,324.634352 1020.5607,326.422269 C1010.68471,328.210152 998.935623,329.1041 985.313551,329.1041 L985.313551,329.1041 L957.042068,329.103834 C950.227513,329.098518 945.007571,329.01346 941.382338,328.848691 C935.93358,328.678431 930.144129,327.997318 924.014204,326.805362 C910.902903,324.421509 901.197197,319.057815 894.896982,310.7143 C891.150911,305.776304 888.852257,300.497734 888.000804,294.878612 C887.660331,293.516412 887.404841,291.983925 887.23455,290.281167 C887.064259,288.578412 886.979168,287.386482 886.979168,286.705377 L886.979168,286.705377 L886.979168,276.233403 L899.749889,276.233403 L899.749889,283.257281 C899.749889,285.896569 899.920179,288.408134 900.260653,290.791995 C901.282289,295.559725 902.814796,299.220661 904.858177,301.774795 C908.944829,307.564168 915.202391,311.2677 923.631075,312.885317 C932.059761,314.502944 942.233686,315.311745 954.153062,315.311745 L954.153062,315.311745 L991.188095,315.311745 C1005.32093,315.311745 1017.07001,313.736691 1026.43524,310.586581 C1035.80036,307.436482 1041.24924,300.753143 1042.78174,290.536586 C1043.12222,286.790517 1043.2925,283.810682 1043.2925,281.597099 L1043.2925,281.597099 L1043.2925,277.255055 C1043.2925,263.292411 1036.822,254.097507 1023.8811,249.670342 C1018.60252,247.797298 1012.21722,246.690507 1004.72507,246.349966 C1000.29784,246.009402 993.571951,245.839133 984.547301,245.839133 L956.196331,245.839133 C946.660922,245.839133 938.402526,245.541141 931.421255,244.945185 C924.439876,244.349218 917.458498,242.68903 910.477229,239.96462 C903.495959,237.24019 897.791708,233.068434 893.364474,227.449315 C889.618403,222.681581 887.319749,217.147605 886.468296,210.847401 C885.957532,207.952714 885.70215,203.610681 885.70215,197.821297 L885.70215,197.821297 L885.70215,193.734658 C885.70215,180.453136 889.10764,170.534553 895.918618,163.978923 C902.729706,157.423297 911.030647,153.251539 920.82155,151.463649 C930.612346,149.675759 942.403979,148.7818 956.196331,148.7818 L956.196331,148.7818 Z M696.500026,165.2818 C666.71716,165.2818 644.188093,170.986473 628.912854,182.395796 C613.637618,193.805141 606,212.362497 606,238.067852 C606,264.048106 613.714267,299.856999 628.912739,311.266302 C632.228869,313.75567 636.34811,308.469171 640.5196,303.098702 L641.215203,302.204166 C644.539723,297.939156 647.870922,293.891865 650.829675,293.9461 C659.037512,294.096574 668.391839,311.758514 674.137739,311.266295 C677.999099,311.508938 681.84823,307.334007 685.567052,303.022821 L686.203266,302.283224 C689.800994,298.093668 693.269386,294.006397 696.500195,293.946144 C703.511766,293.815384 714.216096,311.775009 720.119067,311.401009 C723.801823,311.167674 727.547095,306.838069 731.378762,302.549735 L732.076386,301.771414 C735.68575,297.761956 739.372631,294.010205 743.156825,293.946096 C751.335798,293.807546 758.384118,315.75131 764.317443,311.266295 C779.592692,299.719495 786.99998,263.773182 786.99998,238.067852 C786.99998,212.087544 779.43914,193.461475 764.317491,182.18961 C749.195734,170.917743 726.589941,165.2818 696.500026,165.2818 Z M494.385329,148.7818 L494.385329,228.470961 L343.691065,228.470961 L343.691065,148.7818 L331.17578,148.7818 L331.17578,329.1041 L343.691065,329.1041 L343.691065,242.51875 L494.385329,242.51875 L494.385329,329.1041 L507.15604,329.1041 L507.15604,148.7818 L494.385329,148.7818 Z M242.40895,228.470961 L118.277717,228.470961 L118.277717,242.51874 L228.105749,242.51874 L228.105749,294.878613 C214.653952,308.33041 191.411263,315.056331 158.377708,315.056331 C138.795971,315.056331 122.662325,312.715012 109.976758,308.032435 C97.2911907,303.349859 87.6280271,295.432012 80.9872642,284.278929 C74.3465006,273.125868 71.026119,258.013881 71.026119,238.942951 C71.026119,219.872033 74.3465006,204.760032 80.9872642,193.60695 C87.6280271,182.453889 97.2911907,174.493489 109.976758,169.725746 C122.66232,164.958033 138.795966,162.574165 158.377708,162.574158 C173.702546,162.574165 188.005746,164.319496 201.287285,167.810137 C214.568805,171.300807 224.700232,177.55845 231.681537,186.583065 L232.703193,188.370971 L242.40895,179.176068 L241.387288,177.643575 C233.214012,166.9162 221.550103,159.424051 206.39556,155.167134 C191.240999,150.910252 175.235058,148.7818 158.377708,148.7818 C125.51444,148.7818 100.569006,155.80569 83.5414049,169.853451 C66.5137992,183.901227 58,206.845918 58,238.68754 C58,270.699439 66.4712334,293.729253 83.413698,307.777027 C100.356161,321.824793 125.344161,328.84868 158.377708,328.84868 C175.405315,328.84868 191.453843,326.720243 206.523263,322.463328 C221.592702,318.206432 233.214043,310.714289 241.387288,299.986894 L242.40895,298.709824 L242.40895,228.470961 Z M659,238.399995 L685.470589,238.399995 C681.058824,213.066662 676.647059,200.399995 672.235295,200.399995 C667.82353,200.399995 663.411765,213.066662 659,238.399995 Z M707,238.399995 L733.470589,238.399995 C729.058824,213.066662 724.647059,200.399995 720.235295,200.399995 C715.82353,200.399995 711.411765,213.066662 707,238.399995 Z",
    id: "GHOST-2",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.2858,463.999944 L1013.15811,444.141505 L1031.03706,444.141505 L1049.23531,463.999944 L1053.7689,463.999944 L1035.50678,444.141505 C1038.99741,444.141505 1041.98789,443.907374 1044.47822,443.439113 C1046.96849,442.970859 1049.06502,441.885347 1050.76776,440.182585 C1052.47051,438.479827 1053.32191,435.925685 1053.32191,432.520166 L1053.32191,430.540705 C1053.32191,427.177754 1052.48117,424.644899 1050.7997,422.94214 C1049.11823,421.239382 1047.04297,420.14323 1044.57397,419.653684 C1042.10497,419.164144 1039.14643,418.91937 1035.69834,418.91937 L1010.02928,418.91937 L1010.02928,463.999944 L1013.2858,463.999944 Z M1013.15768,422.431272 L1035.50638,422.431272 C1038.61394,422.431272 1041.13615,422.569621 1043.07306,422.846322 C1045.00997,423.123022 1046.67012,423.857337 1048.05361,425.049265 C1049.4371,426.241199 1050.12887,428.092951 1050.12887,430.604523 L1050.12887,431.881588 C1050.12887,432.903244 1050.1076,433.669489 1050.065,434.180317 C1049.68187,436.862163 1048.29838,438.618133 1045.91452,439.448229 C1043.53067,440.278326 1040.50825,440.693376 1036.84732,440.693376 L1013.15768,440.693376 L1013.15768,422.431272 Z M881.93848,463.999994 L922.74088,463.999994 L922.74088,460.488053 L885.067316,460.488053 L885.067316,442.353657 L913.865243,442.353657 L913.865243,438.841712 L885.067316,438.841712 L885.067316,422.495216 L922.804752,422.495216 L922.804752,418.983274 L881.93848,418.983274 L881.93848,463.999994 Z M770.323631,463.999944 C778.32659,463.999944 784.403304,462.201404 788.553804,458.604322 C792.704273,455.007244 794.77951,449.313641 794.77951,441.523509 C794.77951,435.223296 793.374747,430.22144 790.565194,426.517938 C788.479296,423.793521 785.605895,421.845986 781.944944,420.675338 C778.284017,419.504692 774.410254,418.91937 770.323631,418.91937 L749.82666,418.91937 L749.82666,463.999944 L770.323631,463.999944 Z M770.322259,422.367429 C773.983184,422.367429 777.431272,422.846333 780.666524,423.804132 C783.901749,424.761934 786.370747,426.368914 788.07352,428.625072 C790.372251,431.690041 791.521605,435.968227 791.521605,441.459626 C791.521605,446.951026 790.372251,451.229211 788.07352,454.294179 C786.370747,456.592906 783.901749,458.210529 780.666524,459.147047 C777.431272,460.083565 773.983184,460.551824 770.322259,460.551824 L752.9541,460.551824 L752.9541,422.367429 L770.322259,422.367429 Z M637.124151,418.983274 L611.71044,463.999994 L615.350068,463.999994 L625.438931,446.184865 L648.873187,446.184865 L658.898179,463.999994 L662.66555,463.999994 L637.124151,418.983274 Z M647.08551,442.92829 L627.22705,442.992142 L637.124371,425.432431 L647.08551,442.92829 Z M484.003596,463.999944 L483.875892,444.141505 L501.754875,444.141505 L519.953127,463.999944 L524.486725,463.999944 L506.224627,444.141505 C509.715278,444.141505 512.705757,443.907374 515.196043,443.439113 C517.686328,442.970859 519.782849,441.885347 521.485607,440.182585 C523.188367,438.479827 524.039754,435.925685 524.039754,432.520166 L524.039754,430.540705 C524.039754,427.177754 523.199016,424.644899 521.517533,422.94214 C519.836058,421.239382 517.760826,420.14323 515.291825,419.653684 C512.822812,419.164144 509.864267,418.91937 506.416179,418.91937 L480.74707,418.91937 L480.74707,463.999944 L484.003596,463.999944 Z M483.87548,422.431272 L506.224214,422.431272 C509.331734,422.431272 511.853957,422.569621 513.790849,422.846322 C515.72773,423.123022 517.387917,423.857337 518.77142,425.049265 C520.154911,426.241199 520.846656,428.092951 520.846656,430.604523 L520.846656,431.881588 C520.846656,432.903244 520.825368,433.669489 520.782796,434.180317 C520.399682,436.862163 519.016193,438.618133 516.632326,439.448229 C514.248461,440.278326 511.226057,440.693376 507.565131,440.693376 L483.87548,440.693376 L483.87548,422.431272 Z M369.76981,422.431312 L369.705956,463.999944 L372.962486,463.999944 L372.962486,422.431312 L393.52331,422.431312 L393.52331,418.91937 L349.20898,418.91937 L349.20898,422.431312 L369.76981,422.431312 Z",
    id: "TRADER",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo_full.646cc6a84771c4bea461710a566a8318.svg";
export { ForwardRef as ReactComponent };